module.exports = __webpack_public_path__ + "static/media/0_2020_02_18.07e745fb.jpg";